export default "__VITE_PUBLIC_ASSET__eb82f34c__"